import { render, staticRenderFns } from "./BrandEprdEdit.vue?vue&type=template&id=57b23c14&"
import script from "./BrandEprdEdit.vue?vue&type=script&lang=js&"
export * from "./BrandEprdEdit.vue?vue&type=script&lang=js&"
import style0 from "./BrandEprdEdit.vue?vue&type=style&index=0&id=57b23c14&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports